import React, { Fragment } from 'react';
import { useResource } from 'rest-hooks';
import PropTypes from 'prop-types';

import { UserContext } from '../hooks/useUserContext';
import UserResource from '../resources/UserResource';

const UserProvider = ({ children }) => {
  const userPermissions = useResource(UserResource.permissionsShape(), {});
  return (
    <Fragment>
      <UserContext.Provider value={{ permissions: userPermissions }}>
        {children}
      </UserContext.Provider>
    </Fragment>
  );
};

UserProvider.propTypes = {
  children: PropTypes.element.isRequired
};

export default UserProvider;



// WEBPACK FOOTER //
// ./app/javascript/client/components/UserProvider.jsx